"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcknowledgementFeatureButton = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = require("@amzn/atoz-web/Button");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Flex_1 = require("@amzn/atoz-web/Flex");
const Col_1 = require("@amzn/atoz-web/Col");
const Text_1 = require("@amzn/atoz-web/Text");
const View_1 = require("@amzn/atoz-web/View");
const hooks_1 = require("../../hooks");
const useAcknowledgeAnomaly_1 = require("../../hooks/useAcknowledgeAnomaly");
const Spinner_1 = require("@amzn/atoz-web/Spinner");
const AlertCircleFillIcon_svg_1 = __importDefault(require("../../assets/images/AlertCircleFillIcon.svg"));
const SuccessCheckCircleFill_svg_1 = __importDefault(require("../../assets/images/SuccessCheckCircleFill.svg"));
const react_i18next_1 = require("react-i18next");
const utils_1 = require("../../utils");
const logger_1 = require("../../logger");
const contexts_1 = require("../../contexts");
const AcknowledgementFeatureButton = ({ employeeId, selectedPayPeriod: { startDate, endDate } }) => {
    const { clientName } = (0, contexts_1.useTaaConfigsContext)();
    const [deviationId, setDeviationId] = (0, react_1.useState)('');
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const usageLocation = 'Acknowledgment_Feature';
    const { t } = (0, react_i18next_1.useTranslation)();
    const { data: { items: anomalySearchList = [] } = {}, isLoading: isSearchingAnomaly } = (0, hooks_1.useAnomalySearch)({
        employeeId: employeeId,
        startDate: startDate,
        endDate: endDate,
        anomalyTypes: [hooks_1.AnomalyTypes.TIMECARD_ACKNOWLEDGMENT],
        shouldFetch: true,
        usageLocation,
        deviationStatus: 'OPEN,CLOSED'
    });
    const { useAcknowledgeAnomalyState: { data, loading, error, reset }, acknowledgeAnomaly } = (0, useAcknowledgeAnomaly_1.useAcknowledgeAnomaly)({
        employeeId: employeeId,
        deviationId,
        usageLocation
    });
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const openAcknowledgmentModal = () => {
        utils_1.BIAnalytics.clickOnAcknowledgeButtonInTimeCard();
        logger_1.logger.emitCountMetric({
            metricName: logger_1.METRICS.PAYPERIOD_ACKNOWLEDGEMENT_BUTTON_CLICK.COUNT,
            dimensions
        });
        reset();
        setIsOpen(true);
    };
    const closeAcknowledgmentModal = () => {
        utils_1.BIAnalytics.clickOnCancelButtonInAcknowledgeForm();
        setIsOpen(false);
    };
    const AcknowledgementModalView = () => (react_1.default.createElement(Col_1.Col, { dataTestId: 'acknowledgement-modal-view', backgroundColor: "neutral0", gridGap: "S300", padding: "S500", justifyContent: 'center' },
        react_1.default.createElement(Text_1.Text, { color: '#1768c9' },
            react_1.default.createElement("strong", null, t('time_card_feature_acknowledgement_heading'))),
        react_1.default.createElement(Text_1.Text, null, t('time_card_feature_acknowledgement_title')),
        react_1.default.createElement(Text_1.Text, null, t('time_card_feature_acknowledgement_payperiod_content', {
            startDate: (0, utils_1.getSelectedDateText)(startDate),
            endDate: (0, utils_1.getSelectedDateText)(endDate)
        })),
        react_1.default.createElement(Text_1.Text, null, t('time_card_feature_acknowledgement_declaration_literal')),
        react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', justifyContent: 'space-between', width: '100%' },
            react_1.default.createElement(Button_1.Button, { onClick: closeAcknowledgmentModal }, t('time_card_feature_acknowledgement_cancel_label')),
            react_1.default.createElement(Button_1.Button, { dataTestId: 'modal-acknowledge-button', onClick: () => {
                    utils_1.BIAnalytics.clickOnAcknowledgeButtonInAcknowledgeForm();
                    acknowledgeAnomaly({
                        employeeId: employeeId,
                        deviationId: anomalySearchList[0].deviationId
                    });
                }, variant: Button_1.ButtonVariant.Primary }, t('time_card_feature_acknowledgement_acknowledge_label')))));
    const SuccessCaseForAcknowledgementModalView = () => (react_1.default.createElement(Col_1.Col, { dataTestId: 'acknowledgement-modal-success-view', backgroundColor: "neutral0", gridGap: "S300", padding: "S400" },
        react_1.default.createElement(View_1.View, { style: { textAlign: 'center' } },
            react_1.default.createElement("img", { src: SuccessCheckCircleFill_svg_1.default, alt: 'Success Icon', style: { alignSelf: 'center' }, width: '100' })),
        react_1.default.createElement(Text_1.Text, { fontSize: 'T400', textAlign: 'center' }, t('time_card_feature_acknowledgement_success_title')),
        react_1.default.createElement(Text_1.Text, null, t('time_card_feature_acknowledgement_success_content', {
            startDate: (0, utils_1.getSelectedDateText)(startDate),
            endDate: (0, utils_1.getSelectedDateText)(endDate)
        })),
        react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', justifyContent: 'center', width: '100%' },
            react_1.default.createElement(Button_1.Button, { onClick: closeAcknowledgmentModal, variant: Button_1.ButtonVariant.Primary }, t('time_card_feature_acknowledgement_close_label')))));
    const FailureCaseForAcknowledgementModalView = () => (react_1.default.createElement(Col_1.Col, { dataTestId: 'acknowledgement-modal-failure-view', backgroundColor: "neutral0", gridGap: "S300", padding: "S400" },
        react_1.default.createElement(View_1.View, { style: { textAlign: 'center' } },
            react_1.default.createElement("img", { src: AlertCircleFillIcon_svg_1.default, alt: 'Error Icon', style: { alignSelf: 'center' }, width: '100' })),
        react_1.default.createElement(Text_1.Text, { fontSize: 'T400', textAlign: 'center' }, t('time_card_feature_acknowledgement_failure_title')),
        react_1.default.createElement(Text_1.Text, { textAlign: 'center' }, t('time_card_feature_acknowledgement_failure_content')),
        react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', justifyContent: 'center', width: '100%' },
            react_1.default.createElement(Button_1.Button, { onClick: closeAcknowledgmentModal, variant: Button_1.ButtonVariant.Primary }, t('time_card_feature_acknowledgement_close_label')))));
    const renderAcknowledgementModal = () => {
        if (loading)
            return (react_1.default.createElement(Col_1.Col, { dataTestId: 'acknowledgement-modal-loader-view', backgroundColor: "neutral0", gridGap: "S300", padding: "S300" },
                react_1.default.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.Medium })));
        else if (data)
            return react_1.default.createElement(SuccessCaseForAcknowledgementModalView, null);
        else if (error)
            return react_1.default.createElement(FailureCaseForAcknowledgementModalView, null);
        else
            return react_1.default.createElement(AcknowledgementModalView, null);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.Button, { dataTestId: 'timecard-acknowledge-button', "aria-describedby": "sroDialog", onClick: openAcknowledgmentModal, disabled: !(anomalySearchList && anomalySearchList.length > 0) }, t('time_card_feature_acknowledgement_acknowledge_label')),
        react_1.default.createElement("span", { hidden: true, id: "sroDialog" }, "has pop-up dialog for acknowledgement"),
        react_1.default.createElement(Modal_1.Modal, { isOpen: isOpen, close: closeAcknowledgmentModal, shouldCloseOnClickOutside: false }, renderAcknowledgementModal())));
};
exports.AcknowledgementFeatureButton = AcknowledgementFeatureButton;
